import { render } from "./StatsOverview.vue?vue&type=template&id=ae785aaa&scoped=true"
import script from "./StatsOverview.vue?vue&type=script&lang=js"
export * from "./StatsOverview.vue?vue&type=script&lang=js"

import "./StatsOverview.vue?vue&type=style&index=0&id=ae785aaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae785aaa"]])

export default __exports__